<app-header></app-header>
<main>
  <mat-spinner *ngIf="loading" color="accent" [diameter]="50"></mat-spinner>
  <router-outlet *ngIf="!loading"></router-outlet>
</main>
<app-footer></app-footer>